import { styled } from "@linaria/react"


import { AgentIterationStyles } from "@/components/AgentIteration/AgentIterationStyles.ts"
import { DiffSize } from "@/components/Diff/DiffSize.tsx"
import { EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { Horizontal } from "@/components/Flex.ts"
import { MarkdownWrapper } from "@/components/Markdown/MarkdownWrapper.tsx"
import { ReasoningResult_DiffDialog } from "@/components/ReasoningStep/ReasoningResult_DiffDialog.tsx"
import { CodeFileRegular } from "@/icons/Icons.ts"
import { splitPath } from "@/lib/std.ts"
import * as textStyles from "@/styles/textStyles.ts"
import { Characters } from "@/styles/textStyles.ts"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"

export const ReasoningResult_Diff = (props: {
  content: UIToolCallObservation.Diff
}) => {

  let prefix = ""
  let path = ""
  if (props.content.oldPath && props.content.newPath) {
    prefix = "Updated file"
    path = props.content.oldPath
  } else if (props.content.newPath) {
    prefix = "Created file"
    path = props.content.newPath
  } else if (props.content.oldPath) {
    prefix = "Deleted file"
    path = props.content.oldPath
  }

  const { filename, parentPath } = splitPath(path)

  return (
    <Row>
      <FileIcon />
      {`${prefix}${Characters.Nbsp}`}
      <ReasoningResult_DiffDialog filename={filename} content={props.content} />
      {parentPath && (
        <EllipsisContainer>
          <MarkdownWrapper
            text={`_${parentPath}_`}
            inlineOnly
            className={AgentIterationStyles.secondLevelMarkdown} />
        </EllipsisContainer>
      )}
      <DiffSize added={props.content.diffSize.added} deleted={props.content.diffSize.deleted} />
    </Row>
  )
}

const Row = styled(Horizontal)`
  display: inline-flex;

  align-items: center;
  gap: 4px;

  ${textStyles.smallestFontSize};
  ${textStyles.breakWord};

  color: var(--secondary-text-color);

  :last-child {
    flex-shrink: 0;
  }
`

const FileIcon = styled(CodeFileRegular)`
  width: 12px;
  height: 12px;
`
